<template>
  <StoryblokComponent
    v-if="story"
    :blok="story.content"
  />
</template>
<script setup>
const { slug } = useRoute().params;

const story = await useAsyncStoryblok(
  `knowledge/c/`+slug.join("/"),
  { version: useRuntimeConfig().public.storyblokVersion }
);

const canonical = useCanonicalUrl(story);

// Get the first image from the story content or use a default
const ogImage = computed(() => {
  const content = story.value.content;
  // Look for hero image first
  if (content.body?.[0]?.image?.filename) {
    return content.body[0].image.filename;
  }
  // Fallback to default image
  return 'https://justhire.com/og-image.webp';
});

useSeoMeta({
  title: () => story.value.content.metatags.title,
  description: () => story.value.content.metatags.description,
  ogTitle: () => story.value.content.metatags.title,
  ogDescription: () => story.value.content.metatags.description,
  ogImage: () => ogImage.value,
  ogUrl: () => canonical.value,
  ogType: 'website',
  ogSiteName: () => "Justhire",
  twitterTitle: () => story.value.content.metatags.title,
  twitterDescription: () => story.value.content.metatags.description,
  twitterImage: () => ogImage.value,
  twitterCard: 'summary_large_image',
  twitterSite: '@justhire',
});

useHead({
  link: [
    { rel: 'canonical', href: canonical.value }
  ]
});
</script>
